// extracted by mini-css-extract-plugin
export default {"root":"baseLayout_root__ejdJE"};